// Generates a pseudo-random number with good enough entropy for the average use case
export const genUID = () =>
  Math.random()
    .toString(36)
    .substr(2, 8);
